import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAttendanceByNip } from './firebase';
import { STATUS_FETCHING, STATUS_ERROR, STATUS_READY, STATUS_IDLE } from './constants';

export const fetchAttendanceByNip = createAsyncThunk(
  'getAttendanceByNip',
  async ({ nip, selectedTime }) => await getAttendanceByNip(nip, selectedTime)
);

const userAttendanceSlice = createSlice({
  name: 'userAttendance',
  initialState: {
    status: STATUS_IDLE,
    data: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchAttendanceByNip.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchAttendanceByNip.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchAttendanceByNip.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default userAttendanceSlice.reducer;
